import $ from 'jquery';

const $html = $(`html`);
const $directory = $('.js-directory');
const $directoryButton = $('.js-directory-button');

$directoryButton.on('click', function (event) {
  $directory.toggleClass('is-toggled');
  $html.attr('data-directory', $directory.hasClass('is-toggled'));
});
